export const PWA_UPDATE_EVENT = 'pwa-update-ready'

export async function registerPwaUpdates() {
  if (!('serviceWorker' in navigator)) return
  let reloadOnUpdate = false
  const announce = (worker: ServiceWorker) => window.dispatchEvent(new CustomEvent(PWA_UPDATE_EVENT, { detail: () => { reloadOnUpdate = true; worker.postMessage({ type: 'SKIP_WAITING' }) } }))
  const registration = await navigator.serviceWorker.register('/sw.js')
  if (registration.waiting) announce(registration.waiting)
  registration.addEventListener('updatefound', () => {
    const worker = registration.installing
    worker?.addEventListener('statechange', () => { if (worker.state === 'installed' && navigator.serviceWorker.controller) announce(worker) })
  })
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void registration.update() })
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (reloadOnUpdate) window.location.reload() })
}
